/* eslint-disable react/no-danger */
import React from 'react';
import './spinner-car.scss';
import carImg from 'assets/images/svg/spinners/car.svg';
import carIconImg from 'assets/images/svg/spinners/car-icon.svg';
import credicorpImg from 'assets/images/svg/spinners/credicorp.svg';
import Circle from '../circle/circle';
import { DataLayer } from 'libs/providers/datalayer/datalayer';
import {
  globalFlow,
  VIRTUAL_EVENT_ACTIONS,
  VIRTUAL_EVENT_CATEGORIES,
  VIRTUAL_EVENT_SECTION,
  VIRTUAL_EVENT_SUB_ZONE,
  VIRTUAL_EVENT_TYPE_ELEMENT,
  VIRTUAL_EVENT_TYPE_EVENT,
  VIRTUAL_EVENT_TYPE_ZONE,
  VIRTUAL_EVENT_ZONE,
} from 'libs/providers/datalayer/constants';
import { AppContext } from 'domains/commons/contexts/global/global-provider';
import { LogoBlueBCP } from 'assets/images/svg';
import { useParams } from 'react-router-dom';
import { listChannelBCP } from 'domains/new-quotation/utils/getChannelNotNiubiz';

interface SpinnerCarProps {
  show: boolean;
  title: string;
  text: string;
  credicorp?: boolean;
  bg?: number;
  hashtag?: string;
}

const SpinnerCar = ({
  show,
  title,
  text,
  credicorp,
  bg,
  hashtag,
}: SpinnerCarProps) => {
  const { channel = '' } = useParams()
  const { store } = React.useContext(AppContext);

  React.useEffect(() => {
    if (show) {
      DataLayer.setVirtualEvent({
        category: VIRTUAL_EVENT_CATEGORIES.default,
        action: VIRTUAL_EVENT_ACTIONS.principal,
        label: 'Modal - Datos del Vehículo - Un momento por favor',
        tipoZona: VIRTUAL_EVENT_TYPE_ZONE.autos,
        zona: VIRTUAL_EVENT_ZONE.nuevo,
        subZona: VIRTUAL_EVENT_SUB_ZONE.inicio,
        sección: VIRTUAL_EVENT_SECTION.modal,
        tipoElemento: VIRTUAL_EVENT_TYPE_ELEMENT.modal,
        tipoEvento: VIRTUAL_EVENT_TYPE_EVENT.visualizar,
        valor: 'Un momento por favor',
        flujo: globalFlow(store.dataLayer),
      });
    }
  }, [show]);

  if (!show) return <></>;

  return (
    <div className={`spinner spinner-car ${bg ? `spinner-car-bg--${bg}` : ''}`}>
      <div className="spinner-car__wrapper">
        <img
          src={carImg}
          alt="car logo"
          className="spinner-car__img spinner-car__img--md"
        />
        <img
          src={carIconImg}
          alt="car logo"
          className="spinner-car__img spinner-car__img--xs"
        />
        <h2
          className="spinner-car__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p
          className="spinner-car__text"
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <div className="spinner-car__progress-wrapper">
          <Circle />
        </div>
        <div className="spinner-car__credicorp-wrapper">
          {credicorp && (
            <img
              className="spinner-car__credicorp-wrapper__img"
              src={credicorpImg}
              alt="credicorp logo"
            />
          )}
          {listChannelBCP[channel] && <div className='spinner-car__bcp'>
            <span>En alianza con</span>
            <img src={LogoBlueBCP} alt="logo-bcp" />
          </div>}
        </div>
        {hashtag && <p className="spinner-car__hashtag">{hashtag}</p>}
      </div>
    </div>
  );
};

SpinnerCar.defaultProps = {
  credicorp: false,
  bg: 0,
  hashtag: '',
};

export default SpinnerCar;
